import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { RcsStore } from 'pages/settings/pages/rcs/store/RcsStore'

const RcsContext = createContext<RcsStore | null>(null)

export const useRcsContext = () => {
  const context = useContext(RcsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with RcsProvider')

  return context
}

export const RcsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new RcsStore(entities), [])

  useEffect(() => store.dispose, [])

  return <RcsContext.Provider value={store}>{children}</RcsContext.Provider>
}
